"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importStar(require("react"));

var material_1 = require("@mui/material");

var iconButton_1 = __importDefault(require("../iconButton"));

var IconWithAnimatedText = function (props) {
  var icon = props.icon,
      children = props.children,
      anchor = props.anchor,
      onClick = props.onClick;

  var _a = (0, react_1.useState)(false),
      isLoading = _a[0],
      setIsLoading = _a[1];

  var _b = (0, react_1.useState)(false),
      showText = _b[0],
      setShowText = _b[1];

  var clickHandler = function () {
    setShowText(true);

    if (showText) {
      setShowText(false);
      setIsLoading(true); //funcion que se dispara en el segundo click. 

      onClick();
    }

    ;
  };

  return react_1["default"].createElement(material_1.Grid, {
    container: true,
    alignItems: 'center',
    flexDirection: anchor === 'right' ? 'row-reverse' : 'row'
  }, react_1["default"].createElement(material_1.Grid, {
    item: true
  }, react_1["default"].createElement(iconButton_1["default"], {
    onClick: clickHandler,
    disabled: isLoading,
    startIcon: !isLoading ? icon : react_1["default"].createElement(material_1.CircularProgress, {
      size: '1.25rem'
    })
  })), react_1["default"].createElement(material_1.Grid, {
    item: true
  }, react_1["default"].createElement(material_1.Collapse, __assign({
    orientation: "horizontal",
    "in": showText
  }, {
    timeout: 500
  }), react_1["default"].createElement(material_1.Box, null, children))));
};

exports["default"] = IconWithAnimatedText;